import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import EmailTemplateModel from "../../models/email-template";

export default class EmailTemplateRepository extends BaseRepository {
  static modelClass = EmailTemplateModel;
  modelName = "email-template";
}
